module.exports = __webpack_public_path__ + "static/media/table_background_high.cc786df9.jpg";